import adminRoutes from './routes/admin-routes.js';
import customerRoutes from './routes/customer-routes.js';
import cleanerRoutes from './routes/cleaner-routes.js';
import publicRoutes from './routes/public-routes.js';

export default {

	routes: [

		publicRoutes,

		{
			path: '/admin/signin',
			component: resolve => require ( ['./admin-views/signin.vue'], resolve )
		},

		adminRoutes,

		customerRoutes,

		{
			path: '/cleaner/signin',
			component: resolve => require ( ['./cleaner-views/signin.vue'], resolve )
		},

		cleanerRoutes

	]

};


// WEBPACK FOOTER //
// ./src/custom/_Routes.js